import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useBlocker } from 'react-router'

import { EMPTY_OBJECT } from '../constants/common'
import { isRouterBlockerBlocked } from '../utils/router'

/**
 * Hook to block navigation when `enabled` is true and there are unsaved changes.
 * Prompts the user for confirmation before leaving the page.
 *
 * @param {boolean} enabled - whether to block navigation
 * @param {object} [options]
 * @param {boolean} [options.isSearchChangeBlocked] - also block query-param
 *   navigation within the page, e.g. switching a `?tab=` tab
 */

export function useBlockNavigation(
  enabled,
  { isSearchChangeBlocked = false } = EMPTY_OBJECT
) {
  const { t } = useTranslation()
  const confirmationMessage = t('Modal.UnsavedChangesConfirmationTextKey')

  function shouldBlock({ currentLocation, nextLocation }) {
    return (
      enabled &&
      (currentLocation.pathname !== nextLocation.pathname ||
        (isSearchChangeBlocked &&
          currentLocation.search !== nextLocation.search))
    )
  }

  const blocker = useBlocker(shouldBlock)

  useEffect(() => {
    if (isRouterBlockerBlocked(blocker)) {
      const isConfirmed = window.confirm(confirmationMessage)

      if (isConfirmed) {
        // Delay proceed() to the next tick so the router sees it
        setTimeout(() => blocker.proceed(), 0)
      } else {
        blocker.reset()
      }
    }
  }, [blocker.state])
}
